import { render, staticRenderFns } from "./CreateInvestorModal.vue?vue&type=template&id=ac6f2956&"
import script from "./CreateInvestorModal.vue?vue&type=script&lang=js&"
export * from "./CreateInvestorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports